var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-table',{attrs:{"caption":_vm.$route.query.title,"columns":_vm.columns,"actions":_vm.tableActions,"url":`cdr/tariffs/${_vm.$route.params.id}`,"height":"calc(100vh - 194px)","per-page":100}})
}
var staticRenderFns = []

export { render, staticRenderFns }